import Swiper from 'swiper/dist/js/swiper.min.js'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default {
  name: 'partners-slider',

  componentDidMount () {
    setTimeout(() => {
      this.swiper = new Swiper(this.el, {
        // Optional parameters
        direction: 'horizontal',
        speed: 600,
        // initialSlide: self.el.querySelectorAll('.swiper-slide').length - 3, // 3 car slide-duplicate-...
        // reverseDirection: true,
        loop: false,
        // loopedSlides: 5,
        // Navigation arrows
        /* navigation: {
          nextEl: '.swiper-home-button-next',
          prevEl: '.swiper-home-button-prev',
        }, */
        // spaceBetween: 16,
        // slidesOffsetBefore: 0,
        // slidesPerView: 1,
        spaceBetween: 16,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true,
        },

        /* on: {
          slideChangeTransitionEnd: function () {
            that.updateCounter(this.realIndex)
            that.animate(true)
          },

          slideChangeTransitionStart: function () {
            that.animate(false)
          }
        },, */
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 768px
          340: {
            slidesPerView: 1,
            spaceBetween: 0,
          },

          576: {
            slidesPerView: 2,
            spaceBetween: 16,
          },

          // when window width is >= 768px
          768: {
            slidesPerView: 'auto',
            spaceBetween: 16,
          },
        },
      })
    }, 2000)
  },
}
